'use client'

import { storyblokEditable } from '@storyblok/react/rsc'
import { clsx } from 'clsx'
import { type FC } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokContainerLinkType } from '../../storyblok'
import { useStoryblokWebOrAppLink } from '../../useStoryblokLink'
import { StoryblokComponentsRenderer } from '../StoryblokComponentsRenderer'

export const StoryblokContainerLink: FC<
  StoryblokComponentProps<StoryblokContainerLinkType>
> = ({ blok }) => {
  const { appHref, content, display, href } = blok
  const { target, url } = useStoryblokWebOrAppLink({
    appLink: appHref,
    link: href,
  })

  if (!url) {
    return null
  }

  return (
    <a
      {...storyblokEditable(blok)}
      className={clsx(display === 'block' && 'block')}
      href={url}
      rel={target === '_blank' ? 'noreferrer' : undefined}
      target={target}
    >
      <StoryblokComponentsRenderer bloks={content} />
    </a>
  )
}
